var toIndexedObject = require('../internals/to-indexed-object');

var nativeGetOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;

var DESCRIPTORS = require('../internals/descriptors');

var FAILS_ON_PRIMITIVES = require('../internals/fails')(function () {
  nativeGetOwnPropertyDescriptor(1);
});

var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES; // `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor

require('../internals/export')({
  target: 'Object',
  stat: true,
  forced: FORCED,
  sham: !DESCRIPTORS
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});